export default "__VITE_ASSET__Ch1UtFlW__"